import { Promotion } from "@/@types";
import { PromotionLatestListResponse } from "../../promotion/models/PromotionLatestListResponse";

export function mapPromotionLatestList(response: PromotionLatestListResponse[]): Promotion[] {
    return response.map(promotion => ({
        id: promotion.id,
        title: promotion.title,
        subtitle: promotion.subtitle,
        startDate: promotion.start_date,
        endDate: promotion.end_date,
        hideDate: promotion.hide_date,
        extraPeriod: promotion.extra_period,
        link: promotion.link,
        isBlank: promotion.is_blank,
        slug: promotion.slug,
        order: promotion.order,
        image: promotion.image,
        media: promotion.media,
        fullImage: promotion.full_image,
        fullMedia: promotion.full_media,
    }))
}